import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { alertsApi, AlertRuleCreate, AlertRuleUpdate } from "@/api/alerts";

export function useAlerts(deviceId: string | undefined) {
  return useQuery({
    queryKey: ["alerts", deviceId],
    queryFn: () => alertsApi.list(deviceId!),
    enabled: !!deviceId,
  });
}

export function useCreateAlert(deviceId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: AlertRuleCreate) => alertsApi.create(deviceId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["alerts", deviceId] }),
  });
}

export function useUpdateAlert(deviceId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ruleId, body }: { ruleId: number; body: AlertRuleUpdate }) =>
      alertsApi.update(deviceId, ruleId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["alerts", deviceId] }),
  });
}

export function useDeleteAlert(deviceId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ruleId: number) => alertsApi.delete(deviceId, ruleId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["alerts", deviceId] }),
  });
}
